export enum ApplicantSEADTypeEnum {
    RECIPIENT = "beneficiario",
    SERVER = "servidor",
}